export default __webpack_public_path__ + "static/media/detoxdrinks@3x.93eaf2b4.jpg";